import Link from 'next/link';

const Logo = () => (
  <div className="logo">
    <Link
      href="/"
    >
      <a>
        <h1 className="logo__title">Matlogica</h1>
        <img src={require("./logo.png")} alt="Matlogica logo" className="logo__img"/>
      </a>
    </Link>
  </div>
);

export default Logo;